


























































































import { Component, Vue, Watch } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { porcentagem, required, vetorVazio } from "@/shared/validators";
import DatePicker from "@/shared/components/date-picker.vue";
import SelectConsultor from "@/shared/components/select-consultor.vue";
import { CupomService, Cupom } from "@/services/cupom.service";
import { Parceiro, ParceirosService } from "@/services/parceiros.service";
import ComboPlanos from "./ComboPlanos.vue";
import { Debounce } from "vue-debounce-decorator";
import { Guid } from "guid-typescript";

@Component({
  components: {
    Loading,
    Modal,
    DatePicker,
    SelectConsultor,
    ComboPlanos,
  },
})

export default class Manter extends Vue {
  cupom: Cupom | null = null;
  disabled = false;
  show = false;
  loading = false;
  errors: string[] = [];
  loadingCupom = false;
  rules = {
    cupom: [required() ],
    descricao: [required()],
    porcentagemDescontoCupom: [required(), porcentagem()],
    porcentagemParceiro: [porcentagem()],
    tiposPlanos: [vetorVazio()],
  };

  @Watch('cupom.codCupom')
  @Debounce(300)
  async onPropertyChanged(value: string) {
    this.errors = [];
    if (value) {
      try {
        this.loadingCupom = true;
        const id: string = this.cupom?.idCupom || '';
        const ret = await CupomService.existeCupom(value, id) ;
        if (ret) {
          this.errors =  ['Cupom já cadastrado.'];
        } else {
          this.errors = [];
        }
      }
      finally{
        this.loadingCupom = false;
      }
    }
  }

  get tituloManter(): string {
    if (this.cupom) {
      return this.cupom.idCupom == null ? "Novo Cupom" : "Alterar Cupom";
    }
    return "";
  }

  public async novoCupom() {
    const modal = this.$refs.modal as Modal;
    this.cupom = {
      parceiro: {} as Parceiro,
      ativo: false,
      apenasPrimeiroPlano: false,
      codCupom:''
    } as Cupom;
    this.disabled = false;
    return modal.open();
  }

  public async editarCupom(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.disabled = true;
    this.loading = true;
    this.cupom = await CupomService.obter(id);
    if (this.cupom.idConsultor) {
      this.cupom.parceiro = await ParceirosService.obter(
        this.cupom.idConsultor
      );
    }
    this.loading = false;
    return p;
  }

  async salvarCupom() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      if (this.cupom) {
        if (this.cupom.dataFim && this.cupom.dataFim.length == 10) {
          this.cupom.dataFim = this.cupom.dataFim + " 23:59:59";
        }
        if (this.cupom.parceiro) {
          if (this.cupom.parceiro.idConsultor) {
            this.cupom.idConsultor = this.cupom.parceiro.idConsultor;
          }
        }
        const ids = this.cupom.tiposPlanos.map((x) => x.idTipoPlano);
        const cupomExistente = await CupomService.manter(
          this.cupom,
          ids
        ).finally(() => {
          this.loading = false;
        });
        if (cupomExistente) {
          this.mostraAlerta();
          return;
        }
      }
      this.loading = false;
      return modal.close(true);
    }
  }

  mostraAlerta() {
    this.show = true;
    setTimeout(this.fechaAlerta, 5000);
  }
  fechaAlerta() {
    this.show = false;
  }
  gerarCupom() {
    if (this.cupom) {
      const guidPartes = Guid.create().toString().split('-');
      this.cupom.codCupom = guidPartes[guidPartes.length -1];
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }
}
